import without from 'lodash/without';

function getClass(type){
  switch(type){
    case 'dam_study': 
      return "maki maki-dam icon-inline";
    case "levee_study":
      return "ds ds-levee icon-inline";
    case "cwms": 
      return "ds ds-cwms icon-inline";
    case "silver_jackets":
      return "ds ds-silver-jackets icon-inline";
    case "fema":
      return "ds ds-fema icon-inline";
    case "flood_fight":
      return "ds ds-flood-fight icon-inline";
    case "simdams":
      return "fv fv-simdams icon-inline";
    default:
      return "mdi mdi-map icon-inline";
  }
}

export default {
  name: 'dsSearch',

  getReducer(){
    const initialState = {
      shouldRegister: true,
      shouldHandleSelect: false,
      selectedItem: null,
      activeFilters:['dam_study', 'flood_fight', 'levee_study', 'cwms', 'fema', 'simdams', 'silver_jackets'],
      filters:[
        {name:'dam_study', alias:'Dam Study', icon:'maki maki-dam icon-inline'}, 
      {name:'flood_fight', alias:'Flood Fight', icon:'ds ds-flood-fight icon-inline'}, 
      {name:'levee_study', alias:'Levee Study', icon:'ds ds-levee icon-inline'}, 
      {name:'cwms', alias:'CWMS', icon:'ds ds-cwms icon-inline'},
      {name:'fema', alias:'FEMA', icon:'ds ds-fema icon-inline'}, 
      {name:'silver_jackets', alias:'Silver Jackets', icon:'ds ds-silver-jackets icon-inline'}, 
      {name:'simdams', alias:'NID', icon:'fv fv-simdams icon-inline'}
    ],
    }

    return (state = initialState, { type, payload }) => {
      if(type === 'SEARCH_ITEM_SELECTED'){
        if(payload.selected.provider && payload.selected.provider === 'dsSearch'){
          return Object.assign({}, state, {
            shouldHandleSelect: true,
            selectedItem: payload.selected
          })
        }
      }

      if(type.indexOf('DS_SEARCH_') !== -1){
        return Object.assign({}, state, payload);
      }

      return state;
    }
  },
  doDsAddFilter: (filter) => ({dispatch, store}) => {
    const filterArr = store.selectDsActiveFilters();
    filterArr.push(filter)
    const newArr = filterArr.slice(0);
    dispatch({ type: 'DS_SEARCH_ADD_FILTER', payload: { activeFilters: newArr}});    
  },
  doDsRemoveFilter: (filter) => ({dispatch, store}) => {
    const filterArr = store.selectDsActiveFilters();
    const newFilter = without(filterArr,filter)
    dispatch({ type: 'DS_SEARCH_REMOVE_FILTER', payload: { activeFilters: newFilter }});    
  },
  doDsSearchRegister: () => ({dispatch, store}) => {
    dispatch({ type: 'DS_SEARCH_REGISTERED', payload: { shouldRegister: false }});
    store.doSearchAddCollection({
      onFireSearch: store.doDsSearchFireSearch,
      filters: store.selectDsFilters,
      onAddFilter: store.doDsAddFilter,
      onRemoveFilter: store.doDsRemoveFilter
    })
  },
  doDsSearchFireSearch: (callback) => ({dispatch, store}) => {
    let q = store.selectSearchQueryString();
    if(q.length === 0) return;
    const libraries = store.selectDsLibraries();
    const out = [];
    const filters = store.selectDsActiveFilters();
    libraries.forEach((l) => {
      if(filters.includes(l.LIBRARY_TYPE)) {
        const match = new RegExp(q, 'ig');
      
        if(match.test(l.NAME) || match.test((l.LIBRARY_ID).toString())){
          out.push({
            type: 'Feature',
            provider: 'dsSearch',
            priority: 1,
            displayName: l.NAME,
            iconClass: getClass(l.LIBRARY_TYPE),
            geometry: {
              type: 'Point',
              coordinates: [l.LON, l.LAT]
            },
            properties: l
          })
        }
      }
      
    })
    return callback(null, out);
  },

  doDsSearchHandleSelect: () => ({dispatch, store}) => {
    dispatch({ type: 'DS_SEARCH_HANDLED_SELECT', payload: { shouldHandleSelect: false }});
    const selectedItem = store.selectDsSearchLastSelected();
    if(selectedItem){
      store.doOpenProject(selectedItem.properties);
    }
  },
  selectDsSearchLastSelected: (state) => {
    return state.dsSearch.selectedItem;
  },
  selectDsActiveFilters: (state) => {
    return state.dsSearch.activeFilters;
  },
  selectDsFilters: (state) => {
    return state.dsSearch.filters;
  },
  reactDsSearchShouldHandleSelect: (state) => {
    if(state.dsSearch.shouldHandleSelect) return { actionCreator: 'doDsSearchHandleSelect' };
  },

  reactDsSearchShouldRegister: (state) => {
    if(state.dsSearch.shouldRegister) return { actionCreator: 'doDsSearchRegister' };
  }
}